// @flow

// eslint-disable-next-line no-restricted-imports
import { getStore, type State, type Action } from '@ta/common.state';
import { connect } from 'react-redux';
import { type Dispatch } from 'redux';
import * as React from 'react';
import ApiMonitor from './ApiMonitor';

type MapStateToProps<SP: Object, RSP: Object> = (state: Object, props: SP) => RSP;
type MapDispatchToProps<A, OP: Object, RDP: Object> = (dispatch: Dispatch<A>, ownProps: OP) => RDP;

export type JsonPath = string;
type JsonPathId = string;
export type ApiResponse<T> = {| loading: boolean, data: ?T, error: ?string |};
export type ApiId = string | number;
export type ApiEndpoint = string;
export type ApiHandle<T> = {|
  select: JsonPath => JsonPathId,
  get: (id?: ApiId) => ApiResponse<T>,
|};
type ApiStager = <T>(ApiEndpoint) => ApiHandle<T>;
export type ContainerParams = any;

type DataBinder<ContainerProps: Object, ComponentProps: Object> = (
  State,
  ApiStager,
  params?: ContainerParams,
) => MapStateToProps<ContainerProps, $Shape<ComponentProps>>;

type BindOptions<ContainerProps: Object, ComponentProps: Object> = {|
  data: DataBinder<ContainerProps, ComponentProps>,
  actions: ?MapDispatchToProps<Action, ContainerProps, *> | Object,
|};

type BindArg<ContainerProps: Object, ComponentProps: Object> =
  | BindOptions<ContainerProps, ComponentProps>
  | DataBinder<ContainerProps, ComponentProps>;

// $FlowFixMe92
export type BoundComponent<Props: Object> = React.ComponentType<Props> & {
  stage: (State, ApiStager, params?: ContainerParams) => void,
  load: (params?: ContainerParams) => void,
};

const bind = <ComponentProps: Object, ContainerProps: Object>(
  arg: BindArg<ContainerProps, ComponentProps>,
  // $FlowFixMe92
): ((React.ComponentType<ComponentProps>) => BoundComponent<ContainerProps>) => {
  const options = typeof arg === 'function' ? { data: arg, actions: null } : arg;

  let mapStateToProps: MapStateToProps<ContainerProps, ComponentProps> | null = null;
  return (component): BoundComponent<ContainerProps> => {
    const connectedComponent = connect(
      (state, ownProps) => {
        if (mapStateToProps === null) {
          if (DEBUG) {
            const name = component.displayName || component.name || 'Unknown';
            throw new Error(
              `The container wrapping ${name}'s api calls haven't been staged. You need to call its stage() method in its parent container's bind().`,
            );
          } else {
            throw new Error('Container rendered before staging');
          }
        }
        return mapStateToProps(state, ownProps);
      },
      options.actions,
    )(component);

    ((connectedComponent: any): BoundComponent<ContainerProps>).stage = (state, stage, params) => {
      mapStateToProps = options.data(state, stage, params);
    };

    ((connectedComponent: any): BoundComponent<ContainerProps>).load = param => {
      // $FlowFixMe
      new ApiMonitor(getStore(), connectedComponent, param).reload();
    };

    return ((connectedComponent: any): BoundComponent<ContainerProps>);
  };
};

export default bind;
